import React from "react";
import { ShowrromQrCodeContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import QRCode from "react-qr-code";
import { Buttons } from "components";

class ShowrromQrCodeContainer extends React.Component {
  render() {
    const { onCloseModal } = this.props;
    return (
      <ShowrromQrCodeContainerStyled>
        <div className="qr_code_wrap">
          {/* ไม่ตั้ง id ให้ QRCode เพราะเป็น id ตายตัว ถ้าวันไหนวางหลายใบในหน้าเดียว
              id จะซ้ำกัน แล้ว getElementById จะหยิบใบแรกเสมอ — ถ้าต้องอ้างถึงให้ใช้ ref */}
          <QRCode
            title="Yamaha activity qrcode"
            value={"/showroom"}
            size={156}
          />
        </div>
        <Buttons.BgStandard label={"ปิด"} onClick={onCloseModal} />
      </ShowrromQrCodeContainerStyled>
    );
  }
}

export default withRouter(ShowrromQrCodeContainer);
